import ApiService from '@/utils/ApiService';
import type { TableOfContentsSettingsType, TableOfContentsSavePayload } from '@/modules/table-of-contents';

export function fetchTableOfContentsSettings(
	mapsURL: string,
	mapId: number,
	tocURL: string,
): Promise<{ data: TableOfContentsSettingsType }> {
	return ApiService.get(`${mapsURL}${mapId}${tocURL}`);
}

export function saveTableOfContentsSettings(
	mapsURL: string,
	mapId: number,
	tocURL: string,
	payload: TableOfContentsSavePayload,
): Promise<{ data: TableOfContentsSettingsType }> {
	return ApiService.put(`${mapsURL}${mapId}${tocURL}`, payload);
}
